<div *ngIf="!loading" class="h-100"
    [ngClass]="{'hidden-control': charts.length === 0, 'visible-control': charts.length > 0}">
    <div class="row h-100">
        <div class="col">
            <hr>
            <h6 class="text-uppercase collapsible-text" (click)="patientWellbeingCollapsible.toggleChange()">
                {{chart.text}}&nbsp;
                <app-collapsible #patientWellbeingCollapsible [storageKey]="'well-being'"
                    (collapsibleToggle)="wellBeingsCollapsed=$event">
                </app-collapsible>
            </h6>
        </div>
    </div>
    <div class="row h-100 ml-0 mt-2 mb-2" *ngIf="chart !== undefined && !wellBeingsCollapsed">
        <div class="col my-auto p-0 m-0">
            <div class="row w-100">
                <div class="col text-center pt-2" style="height: 100%; display: table">
                    <!--Well-Being Chart-->
                    <app-patient-summary-chart-well-being *ngIf="visibleIndex === 0" [memberId]="memberId">
                    </app-patient-summary-chart-well-being>
                </div>
            </div>
            <div class="row w-100 text-center" *ngIf="charts.length > 1">
                <div class="col">
                    <span *ngFor="let pointChart of charts; let i = index"
                        [className]="(pointChart === chart ? 'dot p-1 pointer my-auto' : 'dot-empty p-1 pointer my-auto')"
                        (click)="loadChart(i)">
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>